import { getLabelRoleList } from '@modusign/openapi-client-category';
import { useQuery } from 'react-query';

import { useWorkspaceId } from '@app/hooks/useWorkspaceId';
import getAllList from '@app/libs/getAllList';

import { LabelResourceRoleSubject } from '../types';

export default function useLabelRoleList(id: string) {
  const workspaceId = useWorkspaceId();
  return useQuery<
    LabelResourceRoleSubject[],
    Error,
    LabelResourceRoleSubject[],
    ['labelRole', string]
  >({
    queryKey: ['labelRole', id],
    queryFn: async () => {
      const result = await getAllList({
        queryFn: (offset, limit) =>
          getLabelRoleList(workspaceId, id, { limit, offset }).then(({ count, roles }) => ({
            count,
            list: roles,
          })),
      });

      return result.map<LabelResourceRoleSubject>((role) => {
        if (role.subjectType === 'MEMBER') {
          return {
            subjectType: 'MEMBER',
            subjectId: role.subjectId,
            // 멤버의 경우 member property가 있음.
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            memberName: role.member!.name,
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            memberEmail: role.member!.userEmail,
          };
        }

        if (role.subjectType === 'WORKSPACE') {
          return {
            subjectType: 'WORKSPACE',
            subjectId: role.subjectId,
          };
        }

        return {
          subjectType: 'GROUP',
          subjectId: role.subjectId,
          // 그룹인 경우 grup property가 있음.
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          groupType: role.group!.type,
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          groupName: role.group!.name,
        };
      });
    },
    enabled: !!(workspaceId && id),
  });
}
